/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreatePublicApiKeyRequest,
  CreatedPublicApiKeyResponse,
  ProblemDetails,
  PublicApiKeyMetadata,
} from '../models/index';
import {
    CreatePublicApiKeyRequestFromJSON,
    CreatePublicApiKeyRequestToJSON,
    CreatedPublicApiKeyResponseFromJSON,
    CreatedPublicApiKeyResponseToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    PublicApiKeyMetadataFromJSON,
    PublicApiKeyMetadataToJSON,
} from '../models/index';

export interface ApiPartnerApiKeysGetRequest {
    xTenantID?: number;
}

export interface ApiPartnerApiKeysIdRevokePostRequest {
    id: string;
    xTenantID?: number;
}

export interface ApiPartnerApiKeysPostRequest {
    createPublicApiKeyRequest: CreatePublicApiKeyRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class PartnerAPIKeysApi extends runtime.BaseAPI {

    /**
     * List partner Public API keys
     */
    async apiPartnerApiKeysGetRaw(requestParameters: ApiPartnerApiKeysGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PublicApiKeyMetadata>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/partner-api-keys`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PublicApiKeyMetadataFromJSON));
    }

    /**
     * List partner Public API keys
     */
    async apiPartnerApiKeysGet(requestParameters: ApiPartnerApiKeysGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PublicApiKeyMetadata>> {
        const response = await this.apiPartnerApiKeysGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke a partner Public API key
     */
    async apiPartnerApiKeysIdRevokePostRaw(requestParameters: ApiPartnerApiKeysIdRevokePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiPartnerApiKeysIdRevokePost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/partner-api-keys/{id}/revoke`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Revoke a partner Public API key
     */
    async apiPartnerApiKeysIdRevokePost(requestParameters: ApiPartnerApiKeysIdRevokePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiPartnerApiKeysIdRevokePostRaw(requestParameters, initOverrides);
    }

    /**
     * The full key is returned only in this response. Select the read scopes the partner needs. Keys do not expire unless expiresAt is provided.
     * Create a partner Public API key
     */
    async apiPartnerApiKeysPostRaw(requestParameters: ApiPartnerApiKeysPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatedPublicApiKeyResponse>> {
        if (requestParameters['createPublicApiKeyRequest'] == null) {
            throw new runtime.RequiredError(
                'createPublicApiKeyRequest',
                'Required parameter "createPublicApiKeyRequest" was null or undefined when calling apiPartnerApiKeysPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/partner-api-keys`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePublicApiKeyRequestToJSON(requestParameters['createPublicApiKeyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatedPublicApiKeyResponseFromJSON(jsonValue));
    }

    /**
     * The full key is returned only in this response. Select the read scopes the partner needs. Keys do not expire unless expiresAt is provided.
     * Create a partner Public API key
     */
    async apiPartnerApiKeysPost(requestParameters: ApiPartnerApiKeysPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatedPublicApiKeyResponse> {
        const response = await this.apiPartnerApiKeysPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
